import React from "react";
import { Phone, MapPin, MessageCircle } from "lucide-react";

const About = () => {
  return (
    <div className="p-4 max-w-2xl mx-auto space-y-6">
      
      <div>
        <h2 className="text-2xl font-bold text-blue-700 mb-2">
          Kwality Tech Zone LLP
        </h2>
        <p className="text-gray-600 text-sm leading-relaxed">
          Kwality Tech Zone LLP is dedicated to offering premium quality
          electronics, CCTV, networking products, accessories, and home
          essentials. With a commitment to customer satisfaction, we bring a
          seamless shopping and service experience to your fingertips.
        </p>
      </div>

      {/* Location */}
      <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
        <h3 className="font-semibold text-gray-800 flex items-center gap-2 mb-2">
          <MapPin size={18} /> Our Location
        </h3>
        <p className="text-sm text-gray-600 mb-3">
          Visit our store for purchases, support, and demonstrations.
        </p>
        <a
          href="https://maps.app.goo.gl/WHcYD17tYjfz6bK49"
          target="_blank"
          rel="noreferrer"
          className="inline-block bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow hover:bg-blue-700"
        >
          View on Google Maps
        </a>
      </div>

      {/* Contact */}
      <div className="bg-gray-50 p-4 rounded-lg shadow-sm space-y-4">
        <h3 className="font-semibold text-gray-800 mb-2">
          Contact Us
        </h3>
        
        {/* WhatsApp + Call */}
        <div className="flex items-center justify-between bg-white p-3 rounded-lg border">
          <div>
            <p className="text-sm font-semibold">9986333180</p>
            <p className="text-xs text-gray-500">Call / WhatsApp</p>
          </div>
          <div className="flex gap-2">
            <a
              href="tel:9986333180"
              className="bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700"
            >
              <Phone size={16} />
            </a>
            <a
              href="https://wa.me/919060086468"
              target="_blank"
              rel="noreferrer"
              className="bg-green-600 text-white p-2 rounded-full hover:bg-green-700"
            >
              <MessageCircle size={16} />
            </a>
          </div>
        </div>

        {/* Call Only */}
        <div className="flex items-center justify-between bg-white p-3 rounded-lg border">
          <div>
            <p className="text-sm font-semibold">9060086468</p>
            <p className="text-xs text-gray-500">Call Only</p>
          </div>
          <a
            href="tel:9060086468"
            className="bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700"
          >
            <Phone size={16} />
          </a>
        </div>

        {/* IVR Numbers */}
        <div className="bg-white p-3 rounded-lg border text-sm text-gray-700">
          <p><b>Cosmic No:</b> 3636</p>
          <p><b>Centrix No:</b> 6363</p>
        </div>
      </div>
    </div>
  );
};

export default About;
